import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var TriggersGridService = /** @class */ (function (_super) {
    tslib_1.__extends(TriggersGridService, _super);
    function TriggersGridService(http) {
        var _this = _super.call(this, http, MapperService.triggerGridMap) || this;
        _this._endpoint = '/odata/ProcessSchedules';
        return _this;
    }
    TriggersGridService.prototype.setEnabled = function (scheduleIds, enabled) {
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.SetEnabled", JSON.stringify({
            scheduleIds: scheduleIds,
            enabled: enabled,
        }));
    };
    return TriggersGridService;
}(ODataService));
export { TriggersGridService };
